import {COMMESSE_REQUEST, COMMESSE_REQUEST_FAIL, COMMESSE_REQUEST_SUCCESS} from "../utils/ActionTypes";

const INITIAL_STATE = {
    data: [],
    isFetching: false,
    hasError: false,
    errorMessage: "",
    selected: {},
    total: 0,
    rowsPerPage: 5,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case COMMESSE_REQUEST:
            return ({
                ...state,
                isFetching: true,
                hasError: false,
                data: []
            });
        case COMMESSE_REQUEST_SUCCESS :
            //console.log("total",action)
            return ({
                ...state,
                isFetching: false,
                hasError: false,
                data: action.payload.records,
                total: action.payload.total,
            });
        case COMMESSE_REQUEST_FAIL:
            return ({
                ...state,
                isFetching: false,
                hasError: true,
                errorMessage: action.payload.response,
            });

        default :
            return state;

    }
}